import type { UploaderMethodProps } from 'src/app/shared/components/imageUpload';

import type { EndorsementError } from './hooks/useEndorsementForm';

export type UploadResult = { success: true; url: string } | { success: false; error: string };

export function getErrorType(msg: string): EndorsementError['type'] {
	if (msg.includes('authenticated') || msg.includes('401')) return 'UNAUTHORIZED';
	if (msg.includes('400')) return 'VALIDATION';
	return 'SERVER_ERROR';
}

export async function uploadImageToS3(uploader: UploaderMethodProps): Promise<UploadResult> {
	try {
		const result = await uploader.upload();
		const successful = result?.successful || [];
		const uploadURL = successful[0]?.uploadURL;
		if (!uploadURL) {
			return { success: false, error: 'No file was uploaded' };
		}
		return { success: true, url: uploadURL };
	} catch {
		return { success: false, error: 'Error uploading the image' };
	}
}

export async function getPhotoUrl(
	image: string | undefined,
	uploader: UploaderMethodProps,
): Promise<UploadResult | null> {
	if (!image) return null;
	return uploadImageToS3(uploader);
}
